/*
  this is the "foot" entry point for webpack
  files imported here are compiled into head.js or head.css
  see webpack.config.js for configuration
*/

// VENDOR STUFF
import popper from 'popper.js';
import moment from 'moment';
window['moment'] = moment;
import stickyfill from 'stickyfilljs/dist/stickyfill.min.js';
window['stickyfill'] = stickyfill;

// OUR STUFF
import './js/site-search.js';
import './js/item-slider.js';
import './js/eo-slider.js';
import * as Utils from './js/utils.js';
window.idx.utils = Utils;

// IMPORT COMPILED_SCRIPTS DEFINED IN VIEWS.PY
if(context) {
  if(context.compiledScripts) {
    for(var i=0; i<context.compiledScripts.length; i++) {
      import('./js/' + context.compiledScripts[i]).then((module) => {
          module.default();
      })
    }
  }
}

import './js/eo-placeholder.js';
import './js/dom-loaded.js';
import { getUserMessages } from './js/user-messages.js';

// Make getUserMessages available globally
window.getUserMessages = getUserMessages;
if (window.idx && window.idx.userAuthenticated) {
  window.getUserMessages();
}
